import { ITEM_STATUS } from "core/interfaces";

import { getItemPrototypeAdaptedDefault, getItemPrototypeDefault } from "~/common/defaults/item-prototype.default";
import { getMaterialDefault } from "~/common/defaults/material.default";
import { getOrderDefault } from "~/common/defaults/order.default";
import { getSizeAdaptedDefault, getSizeDefault } from "~/common/defaults/size.default";
import type {
	Item,
	ItemAdapted,
	ItemGroup
} from "~/common/interfaces/entities/item.interface";

export const getItemDefault = (): Item => ({
	id: 0,
	status: ITEM_STATUS.IN_STOCK,
	text: "",
	note: "",
	price: 0,
	discountedPrice: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	itemPrototype: getItemPrototypeDefault(),
	material: getMaterialDefault(),
	size: getSizeDefault(),
	order: getOrderDefault()
});

export const getItemAdaptedDefault = (): ItemAdapted => ({
	id: 0,
	status: ITEM_STATUS.IN_STOCK,
	text: "",
	note: "",
	price: {
		price: 0,
		discountedPrice: 0
	},
	discountedPrice: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	itemPrototype: getItemPrototypeAdaptedDefault(),
	material: getMaterialDefault(),
	size: getSizeAdaptedDefault(),
	order: getOrderDefault()
});

export const getItemGroupDefault = (): ItemGroup => ({
	ids: [],
	status: ITEM_STATUS.IN_STOCK,
	text: "",
	note: "",
	price: {
		price: 0,
		discountedPrice: 0
	},
	discountedPrice: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	material: getMaterialDefault(),
	size: getSizeAdaptedDefault(),
	itemPrototype: {
		amount: 0,
		itemPrototype: getItemPrototypeAdaptedDefault()
	},
	order: getOrderDefault()
});
